import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const getCompaniesApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/users/companies`, { params });
};

export const createCompanyApi = (data) => {
  return axios.post(`${API_BASE_URL}/api/admin/companies`, data);
};

export const toggleCompanyStatusApi = (id, companyStatus) => {
  return axios.patch(`${API_BASE_URL}/api/admin/companies/${id}/status`, {
    companyStatus,
  });
};

export const listCompanyCategoriesApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/company-categories`);
};

export const createCompanyCategoryApi = (name) => {
  return axios.post(`${API_BASE_URL}/api/admin/company-categories`, { name });
};

export const deleteCompanyCategoryApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/admin/company-categories/${id}`);
};
